import { graphql } from "gatsby";
import { Trans } from "gatsby-plugin-react-i18next";
import React from "react";

export default function Services() {
  return (
    <>
      <h1 className="my-5 text-center">
        <Trans>SERVICES</Trans>
      </h1>

      <div className="row">
        <div className="d-flex col-md-6 col-lg-4 mb-4">
          <div className="d-flex mt-1">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" className="bi bi-archive" viewBox="0 0 16 16">
              <path d="M0 2a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1v7.5a2.5 2.5 0 0 1-2.5 2.5h-9A2.5 2.5 0 0 1 1 12.5V5a1 1 0 0 1-1-1V2zm2 3v7.5A1.5 1.5 0 0 0 3.5 14h9a1.5 1.5 0 0 0 1.5-1.5V5H2zm13-3H1v2h14V2zM5 7.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5z"></path>
            </svg>
          </div>
          <div className="d-flex flex-column ms-3">
            <div>
              <h3>Antiguidades</h3>
            </div>
            <div>
              <p className="lead">Compramos e vendemos todo o tipo de produtos novos e usados.</p>
            </div>
          </div>
        </div>
        <div className="d-flex col-md-6 col-lg-4 mb-4">
          <div className="d-flex mt-1">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" className="bi bi-archive" viewBox="0 0 16 16">
              <path d="M0 2a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1v7.5a2.5 2.5 0 0 1-2.5 2.5h-9A2.5 2.5 0 0 1 1 12.5V5a1 1 0 0 1-1-1V2zm2 3v7.5A1.5 1.5 0 0 0 3.5 14h9a1.5 1.5 0 0 0 1.5-1.5V5H2zm13-3H1v2h14V2zM5 7.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5z"></path>
            </svg>
          </div>
          <div className="d-flex flex-column ms-3">
            <div>
              <h3>Mobiliário Industrial</h3>
            </div>
            <div>
              <p className="lead">Mobiliário Industrial novo, recuperado, readaptado.</p>
            </div>
          </div>
        </div>
        <div className="d-flex col-md-6 col-lg-4 mb-4">
          <div className="d-flex mt-1">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" className="bi bi-archive" viewBox="0 0 16 16">
              <path d="M0 2a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1v7.5a2.5 2.5 0 0 1-2.5 2.5h-9A2.5 2.5 0 0 1 1 12.5V5a1 1 0 0 1-1-1V2zm2 3v7.5A1.5 1.5 0 0 0 3.5 14h9a1.5 1.5 0 0 0 1.5-1.5V5H2zm13-3H1v2h14V2zM5 7.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5z"></path>
            </svg>
          </div>
          <div className="d-flex flex-column ms-3">
            <div>
              <h3>Carpintaria e Serralharia</h3>
            </div>
            <div>
              <p className="lead">Dispomos de uma avançada oficina.</p>
            </div>
          </div>
        </div>
        <div className="d-flex col-md-6 col-lg-4 mb-4">
          <div className="d-flex mt-1">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" className="bi bi-archive" viewBox="0 0 16 16">
              <path d="M0 2a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1v7.5a2.5 2.5 0 0 1-2.5 2.5h-9A2.5 2.5 0 0 1 1 12.5V5a1 1 0 0 1-1-1V2zm2 3v7.5A1.5 1.5 0 0 0 3.5 14h9a1.5 1.5 0 0 0 1.5-1.5V5H2zm13-3H1v2h14V2zM5 7.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5z"></path>
            </svg>
          </div>
          <div className="d-flex flex-column ms-3">
            <div>
              <h3>Restauro</h3>
            </div>
            <div>
              <p className="lead">Vasta experiência em restauro de móveis.</p>
            </div>
          </div>
        </div>
        <div className="d-flex col-md-6 col-lg-4 mb-4">
          <div className="d-flex mt-1">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" className="bi bi-archive" viewBox="0 0 16 16">
              <path d="M0 2a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1v7.5a2.5 2.5 0 0 1-2.5 2.5h-9A2.5 2.5 0 0 1 1 12.5V5a1 1 0 0 1-1-1V2zm2 3v7.5A1.5 1.5 0 0 0 3.5 14h9a1.5 1.5 0 0 0 1.5-1.5V5H2zm13-3H1v2h14V2zM5 7.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5z"></path>
            </svg>
          </div>
          <div className="d-flex flex-column ms-3">
            <div>
              <h3>Transporte</h3>
            </div>
            <div>
              <p className="lead">Possibilidade de transporte e entregas ao domicílio.</p>
            </div>
          </div>
        </div>
        <div className="d-flex col-md-6 col-lg-4 mb-4">
          <div className="d-flex mt-1">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" className="bi bi-archive" viewBox="0 0 16 16">
              <path d="M0 2a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1v7.5a2.5 2.5 0 0 1-2.5 2.5h-9A2.5 2.5 0 0 1 1 12.5V5a1 1 0 0 1-1-1V2zm2 3v7.5A1.5 1.5 0 0 0 3.5 14h9a1.5 1.5 0 0 0 1.5-1.5V5H2zm13-3H1v2h14V2zM5 7.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5z"></path>
            </svg>
          </div>
          <div className="d-flex flex-column ms-3">
            <div>
              <h3>Orçamento</h3>
            </div>
            <div>
              <p className="lead">Fornecemos orçamentos gratuitos e personalizados.</p>
            </div>
          </div>
        </div>
        <div className="d-flex col-md-6 col-lg-4 mb-4">
          <div className="d-flex mt-1">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" className="bi bi-archive" viewBox="0 0 16 16">
              <path d="M0 2a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1v7.5a2.5 2.5 0 0 1-2.5 2.5h-9A2.5 2.5 0 0 1 1 12.5V5a1 1 0 0 1-1-1V2zm2 3v7.5A1.5 1.5 0 0 0 3.5 14h9a1.5 1.5 0 0 0 1.5-1.5V5H2zm13-3H1v2h14V2zM5 7.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5z"></path>
            </svg>
          </div>
          <div className="d-flex flex-column ms-3">
            <div>
              <h3>Aluguer</h3>
            </div>
            <div>
              <p className="lead">Aluguer de todo o tipo de peças decorativas para cenários, festas, etc.</p>
            </div>
          </div>
        </div>
        <div className="d-flex col-md-6 col-lg-4 mb-4">
          <div className="d-flex mt-1">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" className="bi bi-archive" viewBox="0 0 16 16">
              <path d="M0 2a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1v7.5a2.5 2.5 0 0 1-2.5 2.5h-9A2.5 2.5 0 0 1 1 12.5V5a1 1 0 0 1-1-1V2zm2 3v7.5A1.5 1.5 0 0 0 3.5 14h9a1.5 1.5 0 0 0 1.5-1.5V5H2zm13-3H1v2h14V2zM5 7.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5z"></path>
            </svg>
          </div>
          <div className="d-flex flex-column ms-3">
            <div>
              <h3>Horário</h3>
            </div>
            <div>
              <p className="lead">Segunda a Sábado das 9h às 12.30 e das 14.30 às 19h.</p>
            </div>
          </div>
        </div>
        <div className="d-flex col-md-6 col-lg-4 mb-4">
          <div className="d-flex mt-1">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" className="bi bi-archive" viewBox="0 0 16 16">
              <path d="M0 2a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1v7.5a2.5 2.5 0 0 1-2.5 2.5h-9A2.5 2.5 0 0 1 1 12.5V5a1 1 0 0 1-1-1V2zm2 3v7.5A1.5 1.5 0 0 0 3.5 14h9a1.5 1.5 0 0 0 1.5-1.5V5H2zm13-3H1v2h14V2zM5 7.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5z"></path>
            </svg>
          </div>
          <div className="d-flex flex-column ms-3">
            <div>
              <h3>Atendimento</h3>
            </div>
            <div>
              <p className="lead">Profissionais dedicados e experientes esperam por si!.</p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export const query = graphql`
  query ($language: String!) {
    locales: allLocale(filter: { language: { eq: $language } }) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
  }
`;
